import React from 'react';
import { AlertTriangle, Clock, Edit2, Trash2 } from 'lucide-react';
import { FUEL_META } from './constants';  // Changé: plus de ..
import { fmt, fmtUSD } from './formatters';  // Changé: plus de ..

const TankCard = ({ inv, onEdit, onDelete }) => {
  const meta = FUEL_META[inv.fuel_type] || FUEL_META['JetA'];
  const cap = inv.capacity_gallons || inv.reorder_level_gallons * 4 || inv.current_volume_gallons * 2;
  const pct = cap ? Math.min(100, (inv.current_volume_gallons / cap) * 100) : 50;
  const isLow = inv.reorder_level_gallons && inv.current_volume_gallons <= inv.reorder_level_gallons;

  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700 p-5 hover:border-gray-600 transition">
      <div className="flex justify-between items-start mb-3">
        <div>
          <span className={`px-2 py-1 rounded-lg text-xs font-semibold ${meta.badge}`}>{meta.label}</span>
          <p className="text-gray-400 text-xs mt-1">
            Retail price: <span className="text-white font-medium">{fmtUSD(inv.price_per_gallon)}/gal</span>
          </p>
        </div>
        <div className="flex items-center gap-2">
          {isLow && <AlertTriangle size={14} className="text-yellow-400" />}
          <button onClick={() => onEdit(inv)} className="text-blue-400 hover:text-blue-300 transition">
            <Edit2 size={16} />
          </button>
          <button onClick={() => onDelete(inv)} className="text-red-400 hover:text-red-300 transition">
            <Trash2 size={16} />
          </button>
        </div>
      </div>

      <div className="mb-2">
        <div className="flex justify-between text-xs text-gray-400 mb-1">
          <span>Current volume</span>
          <span className="text-white font-bold">{fmt(inv.current_volume_gallons)} gal</span>
        </div>
        <div className="w-full bg-gray-700 rounded-full h-4 overflow-hidden">
          <div
            className={`h-4 rounded-full transition-all duration-700 ${meta.bar} ${isLow ? 'animate-pulse' : ''}`}
            style={{ width: `${Math.max(2, pct)}%` }}
          />
        </div>
        <div className="flex justify-between text-xs text-gray-500 mt-1">
          <span>
            {inv.capacity_gallons ? `Capacity: ${fmt(inv.capacity_gallons)} gal` : ''}
            {inv.reorder_level_gallons ? ` · Reorder at: ${fmt(inv.reorder_level_gallons)} gal` : ''}
          </span>
          <span>{fmt(pct, 0)}%</span>
        </div>
      </div>

      {inv.last_delivery_date && (
        <div className="text-xs text-gray-500 border-t border-gray-700 pt-3 mt-3">
          <Clock size={11} className="inline mr-1" />
          Last delivery: {new Date(inv.last_delivery_date).toLocaleDateString('en-US')}
          {inv.last_delivery_volume && ` · ${fmt(inv.last_delivery_volume)} gal`}
        </div>
      )}
    </div>
  );
};

export default TankCard;